import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ServicesModule, API_CONFIG } from './services.module';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators';
import { ResultModel, CurrentUserStateModel } from '../model/system.model';
import * as queryString from 'querystring';
import { RechargeRecordModel } from '../model/payment.model';
import {
    PrepareWithdrawModel, PrepareUpdateGoogleAuth, WithdrawMessageModel,
    WithdrawRecordModel, AppDownModel, IHangupUrlModel, IRankingModel
} from '../model/account.model';

@Injectable({
    providedIn: ServicesModule
})
export class AccountService {

    constructor(
        private http: HttpClient,
        @Inject(API_CONFIG) private uri: string
    ) {

    }

    getRankingList(): Observable<ResultModel<IRankingModel>> {
        return this.http.post(this.uri + 'account/ranking-list', null).pipe(
            map((res: ResultModel<IRankingModel>) => res)
        );
    }

    /**
     * 获取云挂机地址URL
     */
    getCloudHangupUrl(): Observable<ResultModel<IHangupUrlModel>> {
        return this.http.post(this.uri + 'account/get-cloud-guaji-url-and-token', null).pipe(
            map((res: ResultModel<IHangupUrlModel>) => res)
        );
    }

    /**
   * 获取存款记录
   */
    searchRecharge(formValue): Observable<ResultModel<RechargeRecordModel>> {
        const params = new HttpParams({ fromString: queryString.stringify(formValue) });
        return this.http.post(this.uri + 'account/search-recharge', params).pipe(map((res: ResultModel<RechargeRecordModel>) => res));
    }
    /**
    * 获取当前登录用户绑定状态
    */
    getBindStatus(): Observable<ResultModel<CurrentUserStateModel>> {
        return this.http.post(this.uri + 'account/get-bind-status', null).pipe(map((res: ResultModel<CurrentUserStateModel>) => res));
    }

    /**
     * google验证
     */
    prepareUpdateGoogleAuth(): Observable<ResultModel<PrepareUpdateGoogleAuth>> {
        return this.http.post(this.uri + 'account/prepare-update-google-auth', null).pipe(map((res: ResultModel<PrepareUpdateGoogleAuth>) => res));
    }

    /**
     * 获取银行卡列表
     */
    prepareBindCard(): Observable<ResultModel<WithdrawMessageModel>> {
        return this.http.post(this.uri + 'account/prepare-bind-card', null).pipe(map((res: ResultModel<WithdrawMessageModel>) => res));
    }


    /**
     * 列出完整的账号信息接口
     * mango 2019-4-30
     */
    getAccountInfo(obj: any) {
        const url = 'account/list-full-info';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 取客服地址
     * mango 2019-6-26
     */
    getKefu() {
        const url = 'utils/service-url';
        const obj = {};
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 查询系统消息
     */
    accountMessageList(obj) {
        const url = 'account/list-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }

    /**
     *已读消息
     */
    accountReadMessage(obj) {
        const url = 'account/read-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }

    /**
     *删除消息
     */
    accountDeleteMessage(obj) {
        const url = 'account/delete-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }
    // 修改用户取款姓名
    getWithDrawName(obj) {
        const url = 'account/modify-withdraw-name';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    // 修改用户登录密码
    getModifyPassword(obj) {
        const url = 'account/modify-password';
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    // 修改用户资金密码
    getWithDrawPassword(obj) {
        const url = 'account/modify-withdraw-password';
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    // 设置资金密码的问题
    getBindSecurity(obj) {
        const url = 'account/bind-security';
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    // 获取随机密保问题
    getRandomSecurity() {
        const url = 'account/get-random-security';
        const obj = {};
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    // 获取Google身份验证二维码
    getGoogleQR() {
        const url = 'account/prepare-google-auth';
        const obj = {};
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    // 设置谷歌验证的操作
    setGoogleAuth(obj) {
        const url = 'account/set-google-auth-bind';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }


    // 添加银行卡
    addBackCard(obj): Observable<ResultModel<any>> {
        const url = 'account/bind-card';
        return this.http.post(this.uri + url, obj).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }

    // 修改用户昵称
    setNickname(obj) {
        const url = 'account/modify-nickname';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 查询转账记录
     * evan 2019-05-06
     */
    searchTransfer(obj) {
        const url = 'account/search-transfer';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 查询转账记录
     * evan 2019-05-06
     */
    searchWithdraw(obj): Observable<ResultModel<WithdrawRecordModel>> {
        const url = 'account/search-withdraw';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<WithdrawRecordModel>) => {
                return res;
            })
        )
    }

    /**
     * 取款操作
     */
    prepareWithdraw(): Observable<ResultModel<PrepareWithdrawModel>> {
        return this.http.post(this.uri + 'account/prepare-withdraw', null).pipe(map((res: ResultModel<PrepareWithdrawModel>) => res));
    }

    /**
     * 获取系统信息数据
     * evan 2019-05-03
     */
    listSystemMessage() {
        const url = 'account/list-system-message';
        const obj = {};
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 清除系统信息数据
     * evan 2019-05-07
     */
    clearSystemMessage() {
        const url = 'account/clear-system-message';
        const obj = {};
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 检查用户名是否存在
     * sing 2019-05-09
     */
    checkUsernameExist(obj) {
        const url = 'account/check-username-exist';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 设置google验证
     * mango 2019-5-13
     */
    updateGoogleAuth(obj) {
        const url = 'account/update-google-auth';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 注册
     * sing 2019-05-10
     */
    regist(obj) {
        const url = 'regist';
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 注册-- 图文验证码
     * mango 2023
     */
    registv1(obj) {
        const url = 'regist-v1';
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 绑定用户银行卡
     * mango 2019-5-13
     */
    setDefaultCard(obj) {
        const url = 'account/set-default-card';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 发送取款申请
     * @param params 取款申请参数
     */
    applyWithdraw(params): Observable<ResultModel<any>> {
        const url = 'account/apply-withdraw';
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }

    /**
     * 获取主账户报表
     * @param {*} param
     * @returns
     * @memberof AccountService
     */
    reportGameLottery(obj) {
        const url = 'account/report-game-all';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }


    /**
   * 获取主账户报表
   * @param {*} param
   * @returns
   * @memberof AccountService
   */
    reportGameLotteryP(obj) {
        const url = 'account/report-game-lottery';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 账变记录
     * @param {*} param
     * @returns
     * @memberof AccountService
     */
    searchBill(obj) {
        const url = 'account/search-bill';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 获取账单明细
     * @param {*} param
     * @returns
     * @memberof AccountService
     */
    getBillDetails(obj) {
        const url = 'account/get-bill-details';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 忘记密码
     * @returns
     * @memberof AccountService
     */
    resetPswBySecurity(obj) {
        const url = 'account/reset-password-by-security';
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /* 收消息
     * @param {*} param
     * @returns
     * @memberof AccountService
     */
    listMessage(obj) {
        const url = 'account/list-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 发消息
     * @param {*} param
     * @returns
     * @memberof AccountService
     */
    sendMessage(obj) {
        const url = 'account/send-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 读消息
     * @returns
     * @memberof AccountService
     */
    readMessage(obj) {
        const url = 'account/read-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }
    /**
     * 删除消息
     * @param {*} param
     * @returns
     * @memberof AccountService
     */
    deleteMessage(obj) {
        const url = 'account/delete-message';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 获取登录地址
     * @param {*} [param]
     * @returns
     * @memberof AccountService
     */
    listLastLoginAddress(obj?) {
        const url = 'account/list-last-login-address';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
    * app下载信息
    * @ returns
    * @ memberof SystemConfigService
    */
    getAppDownUrl() {
        const url = 'utils/mobile-url';
        return this.http.get(this.uri + url, {}).pipe(
            map((res: AppDownModel) => {
                return res;
            })
        )
    }

    /** 添加钱包 */
    bindWallet(obj): Observable<ResultModel<any>> {
        const url = "account/bind-wallet";
        return this.http.post(this.uri + url, obj).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }
    /**
     * 验证资金密码
     */
    verifyFundPws(obj): Observable<ResultModel<any>> {
        const url = 'account/auth-withdraw-password';
        return this.http.post(this.uri + url, obj).pipe(map((res: ResultModel<any>) => {
            return res
        }))

    }

    /**
    * 验证资金密码
    */
    delecteGoogleAuth(obj): Observable<ResultModel<any>> {
        const url = 'account/delete-google-auth-bind';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res
        }))

    }
    /**
     * 个人牛牛报表
     * @param obj 
     */
    reportniuniuLottery(obj) {
        const url = 'account/report-game-niuniu';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }
    /**
     * 极速提现订单
     * @param obj 
     */
    withdrawSpeedOrder() {
        const url = 'account/list-waiting-speed-order';
        return this.http.get(this.uri + url, {}).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        );
    }

    /**
     *
     * 极速提现退单
     * @param {*} obj
     * @returns
     * @memberof AccountService
     */
    CancelWithdrawPay(obj) {
        const url = 'payment/cancel-withdraw-pay';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }
      /**
     *
     * 极速提现确认到帐
     * @param {*} obj
     * @returns
     * @memberof AccountService
     */
       ConfirmWithdrawPay(obj) {
        const url = 'payment/confirm-withdraw-pay';
        const params = new HttpParams({ fromString: queryString.stringify(obj) });
        return this.http.post(this.uri + url, params).pipe(map((res: ResultModel<any>) => {
            return res;
        })
        )
    }  
}
